(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function elvessiaPurchaseConfidenceV4() {
  if (window.__elvessiaPurchaseConfidenceV4) return;
  window.__elvessiaPurchaseConfidenceV4 = true;

  const STYLE_ID = 'elvessia-purchase-confidence-style-v4';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      main[data-template^="product"] .elv-confidence {
        margin: 14px 0 10px;
        font-family: inherit;
        color: currentColor;
      }

      main[data-template^="product"] .elv-confidence__delivery {
        display: flex;
        align-items: flex-start;
        gap: 11px;
        padding: 14px 16px;
        background: #f6f7f7;
        border-radius: 12px;
      }

      main[data-template^="product"] .elv-confidence__dot {
        width: 9px;
        height: 9px;
        flex: 0 0 9px;
        margin-top: 6px;
        border-radius: 999px;
        background: #5d9f8b;
      }

      main[data-template^="product"] .elv-confidence__delivery-copy {
        min-width: 0;
        display: grid;
        gap: 2px;
      }

      main[data-template^="product"] .elv-confidence__eyebrow {
        font-size: 12px;
        line-height: 1.35;
        color: rgba(0, 0, 0, 0.58);
      }

      main[data-template^="product"] .elv-confidence__delivery-text {
        font-size: 14px;
        line-height: 1.4;
        font-weight: 650;
      }

      main[data-template^="product"] .elv-confidence__details-slot {
        margin-top: 8px;
      }

      main[data-template^="product"] .elv-confidence__details-slot:empty {
        display: none;
      }

      main[data-template^="product"] .elv-confidence-accordions {
        margin-top: 14px;
        border-top: 1px solid #e5e5e5;
      }

      main[data-template^="product"] .elv-confidence-accordion {
        border-bottom: 1px solid #e5e5e5;
      }

      main[data-template^="product"] .elv-confidence-accordion > summary {
        position: relative;
        display: flex;
        align-items: center;
        gap: 12px;
        min-height: 56px;
        padding: 15px 34px 15px 0;
        cursor: pointer;
        list-style: none;
        font-size: 14px;
        line-height: 1.4;
        font-weight: 500;
      }

      main[data-template^="product"] .elv-confidence-accordion > summary::-webkit-details-marker {
        display: none;
      }

      main[data-template^="product"] .elv-confidence-accordion > summary::after {
        content: '+';
        position: absolute;
        right: 2px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 22px;
        line-height: 1;
        font-weight: 300;
      }

      main[data-template^="product"] .elv-confidence-accordion[open] > summary::after {
        content: '⌃';
        font-size: 18px;
        top: 48%;
      }

      main[data-template^="product"] .elv-confidence-accordion__icon {
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      main[data-template^="product"] .elv-confidence-accordion__icon svg {
        width: 24px;
        height: 24px;
        display: block;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.5;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      main[data-template^="product"] .elv-confidence-accordion__body {
        padding: 0 0 22px;
        font-size: 14px;
        line-height: 1.65;
        color: rgba(0, 0, 0, 0.86);
      }

      main[data-template^="product"] .elv-confidence-accordion__body p {
        margin: 0 0 14px;
      }

      main[data-template^="product"] .elv-confidence-accordion__body p:last-child {
        margin-bottom: 0;
      }

      main[data-template^="product"] .elv-confidence-accordion__body ul {
        margin: 16px 0 0;
        padding-left: 22px;
      }

      main[data-template^="product"] .elv-confidence-accordion__body li + li {
        margin-top: 4px;
      }

      main[data-template^="product"] .elv-confidence-accordion__body a {
        color: inherit;
        text-decoration: underline;
        text-underline-offset: 2px;
      }

      main[data-template^="product"] .elv-confidence-accordion__title {
        font-weight: 700;
        letter-spacing: 0.01em;
      }

      @media (max-width: 749px) {
        main[data-template^="product"] .elv-confidence {
          margin-top: 12px;
        }

        main[data-template^="product"] .elv-confidence__delivery {
          padding: 13px 14px;
          border-radius: 10px;
        }

        main[data-template^="product"] .elv-confidence-accordion > summary {
          min-height: 54px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getCopy(info) {
    const sourceLines = info.querySelector('.lv-vivaia-ship__lines');
    const texts = sourceLines
      ? [...sourceLines.querySelectorAll('.lv-vivaia-ship__line')]
          .map((node) => normalizeText(node.textContent))
          .filter(Boolean)
      : [];

    return {
      sourceLines,
      delivery:
        texts.find((text) => /estimated/i.test(text) && /deliver/i.test(text)) ||
        'Delivery estimate shown for your destination',
    };
  }

  function createPanel() {
    const panel = document.createElement('section');
    panel.className = 'elv-confidence';
    panel.setAttribute('aria-label', 'Purchase confidence');
    panel.innerHTML = `
      <div class="elv-confidence__delivery">
        <span class="elv-confidence__dot" aria-hidden="true"></span>
        <div class="elv-confidence__delivery-copy">
          <span class="elv-confidence__eyebrow">Delivery estimate</span>
          <strong class="elv-confidence__delivery-text" data-elv-confidence-delivery></strong>
        </div>
      </div>
      <div class="elv-confidence__details-slot" data-elv-product-details-slot></div>
    `;
    return panel;
  }

  function getProductTitle(main) {
    const selectors = [
      '.product-details h1',
      '.elv-vivaia-mobile-intro__title',
      '[data-product-title]',
      'h1',
    ];

    for (const selector of selectors) {
      const node = main.querySelector(selector);
      const text = normalizeText(node?.textContent);
      if (text) return text;
    }

    return '';
  }

  function findProductDetailsAccordion(main, info) {
    const productTitle = getProductTitle(main);
    if (!productTitle) return null;

    return [...info.querySelectorAll('.lv-vivaia-accordion')].find((accordion) => {
      if (accordion.closest('.elv-confidence-accordions')) return false;

      const summaryText = normalizeText(accordion.querySelector('summary')?.textContent);
      if (!summaryText) return false;

      return (
        summaryText === productTitle ||
        (summaryText.length > 20 &&
          (summaryText.includes(productTitle) || productTitle.includes(summaryText)))
      );
    }) || null;
  }

  function moveProductDetailsBlock(main, info, panel) {
    const slot = panel.querySelector('[data-elv-product-details-slot]');
    if (!slot) return;

    const details = findProductDetailsAccordion(main, info);
    const highlights = info.querySelector('.lv-vivaia-icons');

    if (details) {
      details.open = true;
      details.setAttribute('data-elv-moved-product-details', 'true');

      if (details.parentElement !== slot) {
        slot.appendChild(details);
      }
    }

    if (highlights) {
      highlights.setAttribute('data-elv-moved-product-highlights', 'true');

      if (highlights.parentElement !== slot) {
        slot.appendChild(highlights);
      }
    }
  }

  function ensureCareGuideIcon(info) {
    const careBody = info.querySelector('.lv-vivaia-care');
    const summary = careBody?.closest('.lv-vivaia-accordion')?.querySelector('summary');
    if (!summary || summary.querySelector('[data-elv-care-guide-heading]')) return;

    const label = summary.firstElementChild;
    if (!label || normalizeText(label.textContent) !== 'Care Guide') return;

    const heading = document.createElement('span');
    heading.setAttribute('data-elv-care-guide-heading', 'true');
    heading.style.display = 'inline-flex';
    heading.style.alignItems = 'center';
    heading.style.gap = '12px';

    const icon = document.createElement('span');
    icon.className = 'elv-confidence-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 5h14v14H5z"></path><path d="M8 9h8"></path><path d="M8 12h8"></path><path d="M8 15h5"></path></svg>';

    label.replaceWith(heading);
    heading.append(icon, label);
  }

  function createAccordions() {
    const wrapper = document.createElement('div');
    wrapper.className = 'elv-confidence-accordions';
    wrapper.innerHTML = `
      <details class="elv-confidence-accordion">
        <summary>
          <span class="elv-confidence-accordion__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M3 7h11v9H3z"></path><path d="M14 10h3l3 3v3h-6z"></path><circle cx="7" cy="18" r="1.7"></circle><circle cx="17" cy="18" r="1.7"></circle><path d="M2 10h3M1 13h4"></path></svg>
          </span>
          <span>Shipping Information</span>
        </summary>
        <div class="elv-confidence-accordion__body">
          <p>We are cooperating closely with USPS, DHL, UPS, FedEx, Royal Mail, Australia Post and more to deliver all orders fast and securely. This allows us to provide you with reliable tracking numbers so you can always stay up-to-date on your order's whereabouts.</p>
          <ul>
            <li>Returns up to 30 days after delivery</li>
            <li>24/7 customer support to assist you with any questions</li>
          </ul>
        </div>
      </details>
      <details class="elv-confidence-accordion">
        <summary>
          <span class="elv-confidence-accordion__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M5 5h10l4 4v10H5z"></path><path d="M15 5v4h4"></path><path d="M8 14h8"></path><path d="M8 17h5"></path><path d="M3.5 9.5 1.5 12l2 2.5"></path><path d="M2 12h5"></path></svg>
          </span>
          <span>Returns &amp; Refunds</span>
        </summary>
        <div class="elv-confidence-accordion__body">
          <p class="elv-confidence-accordion__title">30 Day Return Policy</p>
          <p>We have a 30-day return policy, which means you have 30 days after receiving your order to request a return. To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging.</p>
        </div>
      </details>
    `;
    return wrapper;
  }

  function updateCopy(info, panel) {
    const copy = getCopy(info);
    const deliveryTarget = panel.querySelector('[data-elv-confidence-delivery]');

    if (deliveryTarget && deliveryTarget.textContent !== copy.delivery) {
      deliveryTarget.textContent = copy.delivery;
    }

    if (copy.sourceLines) copy.sourceLines.hidden = true;
  }

  function enhance() {
    const main = document.querySelector('main[data-template^="product"]');
    if (!main) return;

    const info = main.querySelector('.lv-vivaia-info');
    if (!info) return;

    const ship = info.querySelector('.lv-vivaia-ship');
    const shipHeading = info.querySelector('.lv-vivaia-ship__heading');
    const sourceLines = info.querySelector('.lv-vivaia-ship__lines');
    if (!ship || !shipHeading || !sourceLines) return;

    addStyles();
    ensureCareGuideIcon(info);

    let panel = info.querySelector('.elv-confidence');
    if (!panel) {
      panel = createPanel();
      shipHeading.insertAdjacentElement('afterend', panel);
    }

    moveProductDetailsBlock(main, info, panel);

    let accordions = info.querySelector('.elv-confidence-accordions');
    if (!accordions) {
      accordions = createAccordions();
      const firstExistingAccordion = [...info.querySelectorAll('.lv-vivaia-accordion')].find(
        (element) => !element.closest('.elv-confidence')
      );

      if (firstExistingAccordion) {
        firstExistingAccordion.insertAdjacentElement('beforebegin', accordions);
      } else {
        info.appendChild(accordions);
      }
    }

    updateCopy(info, panel);
  }

  let queued = false;
  function scheduleEnhance() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  }

  function start() {
    enhance();

    const main = document.querySelector('#MainContent');
    if (main) {
      const observer = new MutationObserver(scheduleEnhance);
      observer.observe(main, { subtree: true, childList: true, characterData: true });
    }

    document.addEventListener('shopify:section:load', scheduleEnhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
